import React, { useState } from "react";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";
import { FiUsers, FiCreditCard, FiBookOpen, FiLayers, FiFolder, FiGrid, FiHome, FiClipboard, FiUser, FiInbox } from "react-icons/fi";
import AdminPortfolioManager from "./AdminPortfolioManager";
import AdminContactLeads from "./AdminContactLeads";

const NAV_ITEMS = [
  { key: "students", label: "Students", icon: <FiUsers /> },
  { key: "payments", label: "Payments", icon: <FiCreditCard /> },
  { key: "tests", label: "Tests", icon: <FiBookOpen /> },
  { key: "batches", label: "Batches", icon: <FiLayers /> },
  { key: "resources", label: "Resources", icon: <FiFolder /> },
  { key: "portfolio", label: "Portfolio", icon: <FiGrid /> },
  { key: "homepage", label: "HomePage", icon: <FiHome /> },
  { key: "homeworks", label: "Homeworks", icon: <FiClipboard /> },
  { key: "guardian", label: "Guardian Info", icon: <FiUser /> },
  { key: "leads", label: "Contact Leads", icon: <FiInbox /> },
];

function AdminDashboard() {
  const [active, setActive] = useState("students");

  const logout = async () => {
    await signOut(auth);
    window.location.href = "/admin";
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Topbar */}
      <header className="sticky top-0 z-30 border-b border-gray-200 bg-white/70 backdrop-blur">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 h-14 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="inline-block h-2 w-2 rounded-full" style={{ backgroundColor: "rgb(232, 51, 16)" }} />
            <h1 className="text-base sm:text-lg font-extrabold text-gray-900">Admin Dashboard</h1>
          </div>
          <button
            onClick={logout}
            className="text-xs sm:text-sm font-semibold bg-[#211033] text-white border border-teal-700 rounded-full py-1.5 px-4 hover:bg-white hover:text-[#211033] ease-in duration-300 shadow"
          >
            Log out
          </button>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-6 grid grid-cols-1 md:grid-cols-[240px_1fr] gap-6">
        {/* Sidebar */}
        <aside className="md:sticky md:top-16 h-max rounded-xl border border-gray-200 bg-gray-50 p-2 shadow-sm">
          <nav className="flex md:flex-col gap-1">
            {NAV_ITEMS.map((item) => {
              const isActive = active === item.key;
              return (
                <button
                  key={item.key}
                  onClick={() => setActive(item.key)}
                  className={`flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-semibold transition ${
                    isActive
                      ? "bg-[#211033] text-white border border-teal-700"
                      : "text-gray-700 hover:bg-white hover:text-[#211033] border border-transparent"
                  }`}
                >
                  <span className="text-base">{item.icon}</span>
                  {item.label}
                </button>
              );
            })}
          </nav>
        </aside>

        {/* Content */}
        <section className="rounded-xl border border-gray-200 bg-gray-50 p-5 shadow-sm min-h-[60vh]">
          <h2 className="text-lg font-extrabold text-gray-900 mb-4">{NAV_ITEMS.find(n => n.key === active)?.label}</h2>
          {active === "portfolio" ? (
            <AdminPortfolioManager />
          ) : active === "leads" ? (
            <AdminContactLeads />
          ) : (
            <div className="text-gray-700 text-sm">
              This is a placeholder for the <span className="font-semibold">{active}</span> module. I can scaffold forms, tables, and CRUD flows here using your data model.
            </div>
          )}
        </section>
      </main>
    </div>
  );
}

export default AdminDashboard;
